import {getItem} from "@/utility/localStorageControl";
import Swal from "sweetalert2";
import {format} from 'date-fns';
import moment from 'moment';

export async function imageUrlToBase64(url) {
    console.log(url);
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                if (reader.result) {
                    resolve(reader.result.toString());
                } else {
                    reject(new Error('Failed to convert image to base64'));
                }
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const authHeader = () => {
    const accessToken = getItem("accessToken");
    return {
        timeout: 10000,
        Authorization: `Bearer ${accessToken}`,
    };
};

export const tinyMCEConfig = {
    "api": process.env.VUE_APP_TINYMCE_API,
    "init": {plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount'}
};

export const formattedDate = (date) => {
    try {
        const parsedDate = Date.parse(date);
        return unixToDate(parsedDate / 1000)
    } catch (error) {
        return date;
    }
};

export const unixToDate = (date) => {
    try {
        const unixTimestampMilliseconds = date * 1000;
        const dateObject = new Date(unixTimestampMilliseconds);
        return format(dateObject, 'dd/MM/yyyy');
    } catch (error) {
        return date;
    }
};

export const momentDate = (unixTimestamp) => {
    try {
        const date = moment.unix(unixTimestamp).format('YYYY-MM-DD');
        return `ref<moment.Moment>(moment('${date}', 'YYYY-MM-DD'))`;
    } catch (error) {
        return unixTimestamp;
    }
};

export const showPrompt = async () => {
    return Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#e13832',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, Proceed!',
        cancelButtonText: 'No, Cancel',
        allowEnterKey: false
    });
};

/** Max length stored for URL slugs (align with typical DB column limits). */
export const POST_SLUG_MAX_LENGTH = 120;

const POST_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Derive a URL slug from a title (lowercase, hyphen-separated).
 * @param {string} title
 * @returns {string}
 */
export function slugifyPostTitle(title) {
  return String(title || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, POST_SLUG_MAX_LENGTH);
}

/**
 * Normalize user-entered slug input to the same rules as {@link slugifyPostTitle}.
 * @param {string} input
 * @returns {string}
 */
export function normalizePostSlugInput(input) {
  return slugifyPostTitle(input);
}

/**
 * @param {string} slug
 * @returns {boolean}
 */
export function isValidPostSlug(slug) {
  if (!slug || typeof slug !== "string") {
    return false;
  }
  return slug.length <= POST_SLUG_MAX_LENGTH && POST_SLUG_PATTERN.test(slug);
}